import { render, staticRenderFns } from "./SBSendPHR.vue?vue&type=template&id=10e338aa"
import script from "./SBSendPHR.vue?vue&type=script&lang=js"
export * from "./SBSendPHR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports